import { render, staticRenderFns } from "./add-service-wizard-alarm-detectors.vue?vue&type=template&id=5f37b6d6&scoped=true&"
import script from "./add-service-wizard-alarm-detectors.js?vue&type=script&lang=js&"
export * from "./add-service-wizard-alarm-detectors.js?vue&type=script&lang=js&"
import style0 from "./add-service-wizard-alarm-detectors.css?vue&type=style&index=0&id=5f37b6d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f37b6d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VList,VListGroup,VListItem,VListItemAvatar,VListItemContent,VListItemTitle,VSwitch,VTextField})
